<template>
  <v-navigation-drawer
    v-model="isShowForm"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form class="d-flex flex-column" style="height: calc(100% - 64px)">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>สถานะการส่งคำสั่ง</v-list-item-title>
            <v-list-item-subtitle>
              {{ commandData.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <component :is="commandData.component" :hardware="hardware" />
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import HardwareGetDeviceInfo from '@/views/hardware-device/HardwareGetDeviceInfo'
import HardwareGetDeviceLog from '@/views/hardware-device/HardwareGetDeviceLog'
import HardwareGetEmployee from '@/views/hardware-device/HardwareGetEmployee'
import HardwareGetEmployeeList from '@/views/hardware-device/HardwareGetEmployeeList'
import HardwareGetAccessAuthorityList from '@/views/hardware-device/HardwareGetAccessAuthorityList'
import HardwareSetFirmware from '@/views/hardware-device/HardwareSetFirmware'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    HardwareGetDeviceInfo,
    HardwareGetDeviceLog,
    HardwareGetEmployee,
    HardwareGetEmployeeList,
    HardwareGetAccessAuthorityList,
    HardwareSetFirmware,
    ConfirmDialog,
  },

  props: {
    isShowForm: {
      type: Boolean,
      required: true,
    },
    hardware: {
      type: Object,
      required: true,
    },
    commandData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },

  methods: {
    handleClickBack() {
      this.$emit('onClickBack')
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$emit('onClickBack')
    },
  },
}
</script>
